// src/msalInstance.js
//
// Shared oidc-client-ts UserManager singleton (PingOne / AccessHub). Filename
// kept as-is from the pre-migration MSAL setup (ASTT-7115) to avoid churning
// the two import sites (index.js, axiosInstance.js) for a rename alone.
//
// Unlike the old MSAL setup, this is constructed synchronously — no async
// .initialize() step is needed, so there is no set/get indirection required
// before render. The same instance is passed into react-oidc-context's
// AuthProvider (so component code via useAuth() and non-component code via
// this direct import share one source of truth) and used directly here by
// axiosInstance.js and other non-component files.

import { UserManager } from "oidc-client-ts";
import { oidcConfig } from "./navigation/Auth/MslConfig/MslConfig";

export const userManager = new UserManager(oidcConfig);

// Convenience wrapper: returns the current user's raw access token string,
// or null if there is no signed-in user / the session has expired. Does not
// attempt a silent renew itself — oidc-client-ts's automaticSilentRenew
// (configured in MslConfig.js) keeps the stored user's token fresh in the
// background, so callers can generally just read it.
export const getCurrentAccessToken = async () => {
  const user = await userManager.getUser();
  if (!user || user.expired) return null;
  return user.access_token;
};